// ©2024 Austin App House. All rights reserved.
import React from 'react';

const Sel = ({ col, item }) => (
  <td className={col.className} data-label={col.label} data-th={col.label}>
    {
      col.format
        ? col.format(item[col.value], item)
        : item[col.value]
    }
  </td>
);

export default Sel;
